var _style, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXlsxFile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "70px",
    height: "100px",
    viewBox: "0 0 70 100",
    style: {
      enableBackground: "new 0 0 70 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#485D6E;}\n\t.st1{fill:#6C7D8A;}\n\t.st2{opacity:0.6;}\n\t.st3{fill:#FFFFFF;}\n\t.st4{opacity:0.5;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "70,100 0,100 0,0 50,0 50,20 70,20  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "70,20 50,20 50,0  "
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M16,39l-4.6-6.9h3l3.3,5.3l3.3-5.3h3L19.4,39l4.6,6.9h-3l-3.4-5.2l-3.3,5.2h-3L16,39z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M26,32.1h2.5v11.5h5.9v2.3H26V32.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M35.1,42l2.5-0.6c0.2,1.6,1.4,2.4,2.9,2.4c1.4,0,2.2-0.7,2.2-1.8c0-3-6.6-1.8-6.6-6.3c0-2.4,2-3.8,4.3-3.8 c1.7,0,3.3,0.7,4.2,2.4l-2.1,1.3c-0.5-0.9-1.3-1.5-2.2-1.5c-1,0-1.7,0.6-1.7,1.5c0,2.5,6.6,1.7,6.6,6.3c0,2.6-2.2,4.2-4.8,4.2 C37.9,46.1,35.5,44.7,35.1,42z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M50.6,39L46,32.1h3l3.3,5.3l3.3-5.3h3L54,39l4.6,6.9h-3l-3.4-5.2l-3.3,5.2h-3L50.6,39z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXlsxFile);
export default __webpack_public_path__ + "static/media/xlsx-file.9483e7801a53cccfc59cbb31933642ad.svg";
export { ForwardRef as ReactComponent };